"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBomComplete = void 0;
const common_1 = require("../../common");
class UpdateBomComplete extends common_1.UpdateAction {
}
exports.UpdateBomComplete = UpdateBomComplete;
//# sourceMappingURL=update-bom-complete.action.js.map